import React from "react";
import { connect } from "react-redux";

import { BACKUP_PLAN_SCHEDULE_TYPES } from "App/componentsConfig";
import { objectToArray, createNumberRange } from "utils";
import NextSchedule from "./../../../../../../Dashboard/BackupSettings/Edit/body/Schedule/NextSchedule";
import BackupPlanAdvanced from "./BackupPlanAdvanced";
import BackupPlanStartTime from "./BackupPlanStartTime";
import { SPopupContext } from "../../../../../../common/hoc/SlidingPopup/index";

function BackupPlanSchedule(props) {
  const { sPopupMethods } = React.useContext(SPopupContext);
  const currentType =
    props.enums.ScheduleType.props[props.planSettings.scheduleInfo.type];
  const [pastSchedule, setPastSchedule] = React.useState(0);

  const checkIfCustomWeekdays = () =>
    currentType.key === "CUSTOM" &&
    props.planSettings.scheduleInfo?.weekDays.length === 5 &&
    [1, 2, 3, 4, 5].every(day =>
      props.planSettings.scheduleInfo?.weekDays.includes(day)
    );

  //to show daily when 5 days are checked
  const [isDailyChecked, checkDaily] = React.useState(checkIfCustomWeekdays());

  // nothing to render until we have enums and schedule info
  if (!props.enums || !props.planSettings.scheduleInfo || !currentType) {
    return null;
  }

  const handleDisableSchedule = () => {
    setPastSchedule(props.planSettings.scheduleInfo.type);
    props.setPlanSettings({
      ...props.planSettings,
      scheduleInfo: {
        ...props.planSettings.scheduleInfo,
        type:
          currentType.key === "NO_SCHEDULE"
            ? pastSchedule
            : props.enums.ScheduleType.NO_SCHEDULE
        // weekDays: props.planSettings.scheduleInfo.type.past === 1 ? createNumberRange(7, 0) : [],
        // months: [],
        // monthDays: []
      }
    });
  };

  return (
    <div className="plan_cont_blk summary_wrap summary_schedule is_relative">
      <div className="summary_wrap_body backup_plan_schedule">
        <div className="schedule_backup_wrap schedule_backup_backupset disable_layer1">
          <div className="schedule_wrap2">
            <label className="switch">
              <span className="switch_notify">Backup Schedule</span>
              <input
                type="checkbox"
                checked={currentType.key !== "NO_SCHEDULE"}
                onChange={() => {
                  if (currentType.key === "NO_SCHEDULE") {
                    handleDisableSchedule();
                  } else {
                    sPopupMethods.openPopup("disableScheduleBackup", {
                      execute: () => {
                        sPopupMethods.closePopup();
                        handleDisableSchedule();
                      },
                      cancel: true,
                      secondExecute: () => {
                        sPopupMethods.closePopup();
                      }
                    });
                  }
                }}
              />
              <span className="slider round" />
            </label>
          </div>
        </div>
        <div
          className={`schedule_backup_wrap transparent_layer_schedule ${
            currentType.key === "NO_SCHEDULE" ? "layer_active" : ""
          }`}
        >
          <div className="transparent_layer" />
          <div className="schedule_backup_selection">
            <div className="schedule_backup_selection_wrap">
              <div className="schedule_backup_tabs">
                <h4>Backup frequency</h4>
                <ul className="schedule_backup_ul">
                  {objectToArray(BACKUP_PLAN_SCHEDULE_TYPES).map((val, i) => {
                    const enumKey = props.enums.ScheduleType[val.key];

                    return (
                      <li key={i}>
                        <label className="radio_container">
                          <input
                            type="radio"
                            className="input_radio"
                            checked={
                              currentType.key !== "NO_SCHEDULE" &&
                              (checkIfCustomWeekdays() && isDailyChecked
                                ? props.enums.ScheduleType.DAILY
                                : checkIfCustomWeekdays() && !isDailyChecked
                                ? props.enums.ScheduleType.CUSTOM
                                : props.planSettings.scheduleInfo.type) ===
                                enumKey
                            }
                            name="initial_backup_radio"
                            value={i}
                            onChange={() => {
                              setPastSchedule(
                                props.planSettings.scheduleInfo.type
                              );
                              props.setPlanSettings({
                                ...props.planSettings,
                                scheduleInfo: {
                                  ...props.planSettings.scheduleInfo,
                                  type: enumKey,
                                  ...(enumKey === 1
                                    ? { weekDays: createNumberRange(7, 0) }
                                    : {})
                                }
                              });
                              if (enumKey === props.enums.ScheduleType.DAILY)
                                checkDaily(true);
                              else checkDaily(false);
                            }}
                            tabIndex={0}
                          />
                          <span className="radio_checkmark" />
                          <span className="fs_16">{val.name}</span>
                        </label>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className="schedule_backup_body">
                <div
                  className={[
                    "sche_backup_item",
                    currentType.key === "NO_SCHEDULE"
                      ? "backup_" +
                        props.enums.ScheduleType.props[pastSchedule].name
                      : "backup_" + currentType.name,
                    "active"
                  ].join(" ")}
                >
                  {React.createElement(
                    BACKUP_PLAN_SCHEDULE_TYPES[
                      currentType.key === "NO_SCHEDULE"
                        ? props.enums.ScheduleType.props[pastSchedule].key
                        : checkIfCustomWeekdays(currentType.key) &&
                          isDailyChecked
                        ? "DAILY"
                        : checkIfCustomWeekdays(currentType.key) &&
                          !isDailyChecked
                        ? "CUSTOM"
                        : currentType.key
                    ].component,
                    {
                      planSettings: props.planSettings,
                      setPlanSettings: props.setPlanSettings,
                      checkDaily
                    }
                  )}
                </div>
              </div>
            </div>
            <div
              className={`transparent_layer_schedule ${
                currentType.key === "INTERVAL" ? "layer_active" : ""
              }`}
            >
              <div className="schedule_backup_timer">
                <div className="transparent_layer" />
                <BackupPlanStartTime
                  planSettings={props.planSettings}
                  setPlanSettings={props.setPlanSettings}
                />
              </div>
            </div>
          </div>
          <NextSchedule
            scheduleInfo={props.planSettings.scheduleInfo}
            enums={props.enums}
            clients={props.clients}
            clientDetails={props.clientDetails}
            isBackupPlan={true}
          />
        </div>
        <BackupPlanAdvanced
          planSettings={props.planSettings}
          setPlanSettings={props.setPlanSettings}
        />
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    enums: state.common.enums,
    clients: state.dashboard.clients.list,
    clientDetails: state.backupSettings.clientDetails
  };
}

export default connect(mapStateToProps)(BackupPlanSchedule);
